// removed by extract-text-webpack-plugin
module.exports = {"root":"_34meT","writtenBy":"_qC82c","authorName":"__mvjI","detail":"_3j1aF","avatarImage":"_Y1FE2"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/AuthorDetail/AuthorDetail.scss
// module id = 1162
// module chunks = 2